'use strict';

wbApp.controller('EmailCtrl', ['$scope', '$modal', '$translate', 'recipientSvc', 'messagesSvc', 'messageTemplateSvc',
function ($scope, $modal, $translate, recipientSvc, messagesSvc, messageTemplateSvc) {

    $scope.addAddress = function () {
        addressSelectorPromise.$promise.then(function () {
            $scope.recipient = recipientSvc.createRecipientModel();
            addressSelectorPromise.show();
        });
    }

    $scope.templateModel = messageTemplateSvc.createNew();

    $scope.onAddAddress = function (recipient)
    {
        $scope.recipientList.push(recipient);
    }

    $scope.clearAll = function () {
        $scope.recipientList.length = 0;
        $scope.subject = '';
        $scope.messageBody = '';
        $scope.attachments = [];

        $scope.templateModel = messageTemplateSvc.createNew();
    }

    $scope.sendMessage = function (recipientList, subject, messageBody, attachments) {
        messagesSvc.sendEmail(recipientList, subject, messageBody, attachments)
            .then($scope.clearAll);
    }

    $scope.recipientList = [];

    var addressSelectorPromise = $modal({
        templateUrl: 'messages/address-selector.html',
        show: false,
        scope: $scope
    });


    $scope.getRecipients = function (recipientList) {
        addressListPromise.$promise.then(function () {
            addressListPromise.show();
        });
    }

    $scope.onSaveTemplate = function () {

        $scope.templateModel.subject = $scope.subject;
        $scope.templateModel.messageBody = $scope.messageBody;
        $scope.templateModel.recipients = $scope.recipientList;
        if (!$scope.templateModel.name) {
            $scope.templateModel.name = $scope.templateModel.subject;
        }

        saveTemplateDialogPromise.$promise.then(function () {
            saveTemplateDialogPromise.$scope.model = angular.copy($scope.templateModel);
            saveTemplateDialogPromise.$scope.onSave = function (savedData) {
                $scope.templateModel.name = savedData.name;
                $scope.templateModel.id = savedData.id;
            };
            saveTemplateDialogPromise.show();
        });
    }

    $scope.onLoadTemplate = function () {
        loadTemplateDialogPromise.$promise.then(function () {
            loadTemplateDialogPromise.$scope.onLoad = function (loadedData) {
                $scope.templateModel = loadedData;

                $scope.subject = loadedData.subject;


                $scope.recipientList = _.map(loadedData.recipients, function (recipientInfo) {
                    var recipient = recipientSvc.createRecipientModel();
                    angular.extend(recipient, recipientInfo);
                    return recipient;
                });

                $scope.messageBody = loadedData.messageBody;
                $scope.attachments = [];
            };
            loadTemplateDialogPromise.show();            
        });
    }

    var uploadComponent = null;
    $scope.uploadUrl = "restapi/emails/attachment";
    $scope.uploadSuccess = false;
    $scope.uploadFullSuccess = false;
    $scope.uploadError = false;
    $scope.uploadInProgress = false;
    $scope.attachments = [];

    $scope.removeAttachment = function (attachment) {
        if (!$scope.attachments || !attachment) {
            return;
        }

        var idx = $scope.attachments.indexOf(attachment);
        if (idx !== -1) {
            $scope.attachments.splice(idx, 1);
        }
    }

    $scope.fileUploaderOptions = {
        accept: "*",
        uploadMode: "instantly",
        showFileList: false,
        labelText: "",
        selectButtonText: $translate.instant('TXT_ATTACHMENT_ADD'),
        maxFileSize: 1024 * 1024 * 10, // 20 MB
        onContentReady: function (e) {
            uploadComponent = e.component;
        },
        onUploadError: function (e) {
            alert(e.request.responseText);
            $scope.uploadSuccess = false;
            $scope.uploadError = true;
            $scope.uploadInProgress = false;
            uploadComponent.reset();
        },
        onUploadStarted: function (e) {
            $scope.uploadSuccess = false;
            $scope.uploadError = false;
            $scope.uploadInProgress = true;
        },
        onUploaded: function (e) {
            $scope.attachments.push(JSON.parse(e.request.responseText));
            $scope.uploadSuccess = true;
            $scope.uploadError = false;
            $scope.uploadInProgress = false;
            uploadComponent.reset();
        },
        bindingOptions: {
            uploadUrl: "uploadUrl",
            disabled: "form.$invalid"
        }
    };

    var addressListPromise = $modal({
        templateUrl: 'messages/address-list.html',
        show: false,
        scope: $scope
    });

    var saveTemplateDialogPromise = $modal({
        templateUrl: 'messages/email-template-save-dialog.html',
        show: false,
        scope: $scope.$new()
    });

    var loadTemplateDialogPromise = $modal({
        templateUrl: 'messages/email-template-load-dialog.html',
        show: false,
        scope: $scope.$new()
    });
}]);
